import { useState, useEffect } from 'react';
import { useResizeObserver } from './useResizeObserver';

function usePageWidthLessThan(limitedWidth = 720) {
  const [limitedSize, setLimitedSize] = useState(false);
  const { width } = useResizeObserver();

  useEffect(() => {
    if (width > limitedWidth) {
      setLimitedSize(false);
    } else {
      setLimitedSize(true);
    }
  }, [limitedWidth, width]);

  return [limitedSize];
}

export { usePageWidthLessThan };
